import { isInternal, isInternalSync } from './isInternal';

export abstract class UserService {
  public static isInternal = isInternal;
  public static isInternalSync = isInternalSync;
}
